// @flow
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import * as React from "react";
import Grid from "@material-ui/core/Grid";

type Props = {
  children: React.Node,
  subInfo?: string,
  mt?: number,
};

function PageHeading({ children, subInfo, mt = 4 }: Props) {
  const Heading = () => (
    <Typography variant="h5" component="h2">
      <b>{children}</b>
    </Typography>
  );

  const SubHeading = () => (
    <Typography color="textSecondary" variant="body2">
      {subInfo}
    </Typography>
  );

  if (subInfo) {
    return (
      <Box mb={2} mt={mt}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-end"
        >
          <Grid item>
            <Heading />
          </Grid>
          <Grid item style={{ paddingBottom: 3 }}>
            <SubHeading />
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <Box mb={2} mt={mt}>
      <Heading />
    </Box>
  );
}

export default PageHeading;
